import { Link } from 'react-router-dom';
import FurnitureNavbar from '../../../components/layout/Nav';
import './dashboard.scss';
import { useEffect, useState } from 'react';
import withAuth from '../../auth/WithAuth';
import { serverUrlAuth } from '../../../serverUrl';
import {
  FaHandshake,
  FaWhatsapp,
  FaBell,
  FaProjectDiagram,
  FaCheckCircle,
  FaCalendarAlt,
  FaRocket,
  FaChevronRight,
  FaFileAlt,
} from 'react-icons/fa';

const ClientDashboard = () => {
  const [fullName, setFullName] = useState('');
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const name = localStorage.getItem('full_name');
    if (name) setFullName(name.split(' ')[0]);

    const fetchDashboardData = async () => {
      try {
        const response = await serverUrlAuth.get('projects/client-dashboard/');
        console.log('Dashboard data:', response.data);
        setDashboardData(response.data);
      } catch (err) {
        console.error('Error fetching dashboard:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);




  if (loading) {
    return (
      <>
        <FurnitureNavbar />
        <div className="dashboard-loader">
          <div className="wooden-spinner"></div>
          <p>Crafting your experience...</p>
        </div>
      </>
    );
  }

  const data = dashboardData || {};

  return (
    <>
      <FurnitureNavbar />
      <div className="modern-dashboard">
        {/* Hero Section */}
        <section className="hero-craftsmanship">
          <div className="hero-pattern"></div>
          <div className="hero-content-modern">
            <div className="welcome-badge">
              <span className="badge-icon">✨</span>
              <span>
                Welcome back,{' '}
                {fullName || data.client_name?.split(' ')[0] || 'Client'}!
              </span>
            </div>
            <h1 className="hero-title">
              <span className="gradient-text">Turn Your Vision</span>
              <span className="hero-accent">Into Reality</span>
            </h1>
            <p className="hero-subtitle">
              Where exceptional craftsmanship meets your unique style. Design,
              create, and transform your space with Kenya's finest artisans.
            </p>
            <div className="hero-actions">
              <Link to="/new-project" className="btn-primary-custom">
                <FaRocket /> Start New Project
              </Link>
              <Link to="/messages" className="btn-secondary-custom">
                 Messages
                {data.combined_unread_negotiation_and_updates > 0 && (
                  <span className="notification-dot">
                    {data.combined_unread_negotiation_and_updates}
                  </span>
                )}
              </Link>
            </div>
          </div>
        </section>

        {/* Quick Stats Dashboard */}
        <div className="stats-dashboard">
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#67320020', color: '#673200' }}
            >
              <FaProjectDiagram />
            </div>
            <div className="stat-content">
              <h3>{data.open_projects || 0}</h3>
              <p>Open Projects</p>
            </div>
          </div>
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#4caf5020', color: '#4caf50' }}
            >
              <FaCheckCircle />
            </div>
            <div className="stat-content">
              <h3>{data.ongoing_projects || 0}</h3>
              <p>In Progress</p>
            </div>
          </div>
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#ff980020', color: '#ff9800' }}
            >
              <FaCheckCircle />
            </div>
            <div className="stat-content">
              <h3>{data.completed_projects || 0}</h3>
              <p>Completed</p>
            </div>
          </div>
          <div className="stat-card-modern">
            <div
              className="stat-icon-wrapper"
              style={{ background: '#9c27b020', color: '#9c27b0' }}
            >
              <FaHandshake />
            </div>
            <div className="stat-content">
              <h3>{data.active_negotiations?.length || 0}</h3>
              <p>Negotiations</p>
            </div>
          </div>
        </div>

        {/* Projects Grid Section - Ongoing Projects */}
        {data.ongoing_projects_data &&
          data.ongoing_projects_data.length > 0 && (
            <div className="projects-showcase">
              <div className="section-header-modern">
                <h2>
                  <span className="header-icon">🎯</span>
                  Ongoing Projects
                  <span className="header-line"></span>
                </h2>
                <Link to="/my-requests" className="view-all-link">
                  View All Projects <FaChevronRight />
                </Link>
              </div>
              <div className="projects-grid-modern">
                {data.ongoing_projects_data.map((project) => (
                  <div key={project.id} className="project-card-modern">
                    <div className="project-header">
                      <div className="project-title-section">
                        <h3>{project.title}</h3>
                        <span className="project-artisan">
                          {project.artisan_name || 'Artisan assigned'}
                        </span>
                      </div>
                      <div className="project-budget">
                        KSh {(project.budget || 0).toLocaleString()}
                      </div>
                    </div>
                    <div className="progress-modern">
                      <div className="progress-bar-modern">
                        <div
                          className="progress-fill-modern"
                          style={{ width: `${project.progress || 0}%` }}
                        ></div>
                      </div>
                      <div className="progress-stats">
                        <span>{project.progress || 0}% Complete</span>
                        <span>
                          Due{' '}
                          {project.due_date
                            ? new Date(project.due_date).toLocaleDateString()
                            : 'Not set'}
                        </span>
                      </div>
                    </div>
                    <div className="project-footer">
                      <div className="milestone-chip">
                        <span>
                          🎯 Next:{' '}
                          {project.next_milestone || 'Material Preparation'}
                        </span>
                      </div>
                      <Link to={`/messages`} className="project-action">
                        View Updates →
                      </Link>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

        {/* Two Column Layout */}
        <div className="dashboard-grid-modern">
          {/* Left Column - Recent Updates */}
          <div className="dashboard-card">
            <div className="card-header">
              <h3>
                <FaBell /> Recent Updates
              </h3>
              <Link to="/project-updates" className="card-link">
                See all
              </Link>
            </div>
            <div className="activity-timeline">
              {data.update_notifications &&
              data.update_notifications.length > 0 ? (
                data.update_notifications.slice(0, 5).map((update) => (
                  <div
                    key={update.id}
                    className={`timeline-item ${!update.is_read ? 'new' : ''}`}
                  >
                    <div className="timeline-dot"></div>
                    <div className="timeline-content">
                      <div className="timeline-header">
                        <h4>{update.project_title}</h4>
                        {!update.is_read && (
                          <span className="new-badge">New</span>
                        )}
                      </div>
                      <p>{update.message}</p>
                      <span className="timeline-time">{update.time}</span>
                    </div>
                  </div>
                ))
              ) : (
                <div className="empty-activity">
                  <p>No recent updates</p>
                </div>
              )}
            </div>
          </div>

          {/* Right Column - Recent Proposals */}
          <div className="dashboard-card proposals-card">
            <div className="card-header">
              <h3>
                <FaFileAlt /> Recent Proposals
              </h3>
              <Link to="/my-requests" className="card-link">
                View all →
              </Link>
            </div>
            <div className="proposals-list">
              {data.proposal_notifications &&
              data.proposal_notifications.length > 0 ? (
                data.proposal_notifications.map((proposal) => (
                  <div key={proposal.id} className="proposal-item">
                    <div className="proposal-header">
                      <div className="proposal-project">
                        <h4>{proposal.project_title}</h4>
                        <span className="proposal-artisan">
                          {proposal.artisan_name}
                        </span>
                      </div>
                      <div className="proposal-price">
                        KSh {proposal.proposed_price?.toLocaleString() || 0}
                      </div>
                    </div>
                    <div className="proposal-details">
                      <div className="proposal-footer">
                        <span className="proposal-date">
                          <FaCalendarAlt /> Due:{' '}
                          {proposal.completion_date
                            ? new Date(
                                proposal.completion_date,
                              ).toLocaleDateString()
                            : 'Not set'}
                        </span>
                        <Link to={`/projects`} className="review-proposal-btn">
                          Review Proposal →
                        </Link>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="empty-proposals">
                  <p>No proposals received yet</p>
                  {/* <Link to="/new-project" className="create-project-link">
                    Create a project to receive proposals
                  </Link> */}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withAuth(ClientDashboard, 'client');
